// @ts-ignore
import { createRequestActions } from 'helpers/redux/createRequestActions'
import { createRequestActions as request } from 'store/actionCreators'
// @ts-ignore
import { parseRequestParamsForFeed } from 'helpers/urlHelper'
// @ts-ignore
import * as types from './actionTypes'

export const fetchLeaderBoard = request('FEED/FETCH_LEADER_BOARD', ({ team, range }) => ({
  request: {
    url: parseRequestParamsForFeed(team, range),
  },
}))

export const feedRecent = {
  get: createRequestActions({
    request: types.FEED_RECENT.GET.REQUEST,
    success: types.FEED_RECENT.GET.SUCCESS,
    fail: types.FEED_RECENT.GET.FAIL,
  }),
}

export const setLeaderBoardSection = (section: any) => ({
  type: types.FEED_LEADER_BOARD_SET_SECTION,
  payload: {
    section,
  },
})

export const setTab = (tab: any) => ({
  type: types.FEED_SET_TAB,
  payload: {
    tab,
  },
})

export const addFeedRecentFromSockets = (feedRecentSingle: any) => ({
  type: types.FEED_RECENT_FROM_SOCKETS,
  payload: {
    feedRecentSingle,
  },
})

export const addStoryFromSockets = (storySingle: any) => ({
  type: types.FEED_STORY_FROM_SOCKETS,
  payload: {
    storySingle,
  },
})

export const feedRecentLoadMore = {
  get: createRequestActions({
    request: types.FEED_RECENT_LOAD_MORE.GET.REQUEST,
    success: types.FEED_RECENT_LOAD_MORE.GET.SUCCESS,
    fail: types.FEED_RECENT_LOAD_MORE.GET.FAIL,
  }),
}

export const enableFeedRecentGetPending = {
  type: types.FEED_RECENT_ENABLE_GET_PENDING,
}

export const enableFeedRecentLoadMorePending = {
  type: types.FEED_RECENT_ENABLE_LOAD_MORE_PENDING,
}

export const feedRecentScroll = ({ scrollTop, clientHeight, scrollHeight }: any) => ({
  type: types.FEED_RECENT_SCROLL,
  payload: {
    scrollTop: {
      recent: scrollTop,
    },
    clientHeight,
    scrollHeight,
  },
})

export const feedStories = {
  get: createRequestActions({
    request: types.FEED_STORIES.GET.REQUEST,
    success: types.FEED_STORIES.GET.SUCCESS,
    fail: types.FEED_STORIES.GET.FAIL,
  }),
}

export const feedStoriesLoadMore = {
  get: createRequestActions({
    request: types.FEED_STORIES_LOAD_MORE.GET.REQUEST,
    success: types.FEED_STORIES_LOAD_MORE.GET.SUCCESS,
    fail: types.FEED_STORIES_LOAD_MORE.GET.FAIL,
  }),
}

export const enableFeedStoriesGetPending = {
  type: types.FEED_STORIES_ENABLE_GET_PENDING,
}

export const enableFeedStoriesLoadMorePending = {
  type: types.FEED_STORIES_ENABLE_LOAD_MORE_PENDING,
}

export const feedStoriesScroll = ({ scrollTop, clientHeight, scrollHeight }: any) => ({
  type: types.FEED_STORIES_SCROLL,
  payload: {
    scrollTop: {
      stories: scrollTop,
    },
    clientHeight,
    scrollHeight,
  },
})

export const setFilterByTeam = (team: any) => ({
  type: types.FEED_SET_FILTER_BY_TEAM,
  payload: {
    team,
  },
})

export const setFilterByRange = (range: any) => ({
  type: types.FEED_SET_FILTER_BY_RANGE,
  payload: {
    range,
  },
})

export const setFeedEventLikeOld = (index: any) => ({
  type: types.FEED_SET_EVENT_LIKE_OLD,
  payload: {
    index,
  },
})

export const setFeedStoryLikeOld = (index: any) => ({
  type: types.FEED_SET_STORY_LIKE_OLD,
  payload: {
    index,
  },
})

export const setReaction = ({ emoji, activityUserStoryId, eventId, user }: any) => ({
  type: types.FEED_SET_REACTION,
  payload: {
    emoji,
    activityUserStoryId,
    eventId,
    user,
  },
})

export const updateReaction = ({ reaction, emoji }: any) => ({
  type: types.FEED_UPDATE_REACTION,
  payload: {
    reaction,
    emoji,
  },
})

export const addReactionFromSockets = (reaction: any) => ({
  type: types.FEED_SET_REACTION_FROM_SOCKETS,
  payload: {
    reaction,
  },
})

export const updateReactionFromSockets = (reaction: any) => {
  return {
    type: types.FEED_UPDATE_REACTION_FROM_SOCKETS,
    payload: {
      reaction,
    },
  }
}

export const updateStoryFromSockets = (payload: any) => ({
  type: types.FEED_UPDATE_STORY_FROM_SOCKETS,
  payload,
})

export const feedStoryActivity = {
  get: createRequestActions({
    request: types.FEED_STORY_ACTIVITY.GET.REQUEST,
    success: types.FEED_STORY_ACTIVITY.GET.SUCCESS,
    fail: types.FEED_STORY_ACTIVITY.GET.FAIL,
  }),
}

export const removeUnreadStoryAuthor = () => ({
  type: types.FEED_REMOVE_UNREAD_STORY_AUTHOR,
})

export const storiesUnreadCount = {
  get: createRequestActions({
    request: types.FEED_STORIES_UNREAD_COUNT.GET.REQUEST,
    success: types.FEED_STORIES_UNREAD_COUNT.GET.SUCCESS,
    fail: types.FEED_STORIES_UNREAD_COUNT.GET.FAIL,
  }),
}

export const storiesMarkedRead = {
  get: createRequestActions({
    request: types.FEED_STORIES_MARKED_READ.GET.REQUEST,
    success: types.FEED_STORIES_MARKED_READ.GET.SUCCESS,
    fail: types.FEED_STORIES_MARKED_READ.GET.FAIL,
  }),
}

export const updateStoryApiRequest = request('FEED/UPDATE_STORY', ({ activityId, story, mentions, storyId }) => ({
  request: {
    url: '/activities-users-stories',
    method: 'PUT',
    data: {
      activityId,
      story,
      mentions,
      storyId,
    },
  },
}))

export const deleteStoryApiRequest = request('FEED/DELETE_STORY', ({ storyId }) => ({
  request: {
    url: '/activities-users-stories',
    method: 'DELETE',
    data: {
      storyId,
    },
  },
}))
